// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    getSystemList as getSystemListApi,
    GetSystemListApiParameter,
    GetSystemListModel,
    GetSystemListValuesModel,
} from "@eisinc/App/Services/SystemListService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";


type HandlerType = ApiHandlerDiscreteParameter<
    GetSystemListApiParameter & HasOnSuccess & { onError?: (error: string) => void },
    GetSystemListApiParameter,
    ServiceResult<GetSystemListValuesModel[]>
>;

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getSystemListApi(props.parameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [SendDataToApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const getSystemList = createHandlerChainRunner(chain, "GetSystemList");
export default getSystemList;
